module.exports = __webpack_public_path__ + "img/ico_cart.e1d84c65.svg";